import { SidebarInset } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

export function AdminPageContent({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <SidebarInset className={cn('flex-grow', className)}>
      {children}
    </SidebarInset>
  );
}
